import { useMemo } from 'react';
import config from '../config';

const toBool = (value) => value === 'true';

const useFlags = () =>
  useMemo(
    () => ({
      mockClaims: toBool(config.mockData),
      mockPolicies: toBool(config.mockData),
      mockPayments: toBool(config.mockData),
      showComingSoon: toBool(config.showComingSoon),
    }),
    [],
  );

export default useFlags;
